import { Actions } from '../actions/client';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IOrganization } from '../interfaces/organization';

export type State = DeepReadonly<{
  isFetching: boolean;
  client: IOrganization | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  client: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_CLIENT_REQUEST':
      return {
        ...state,
        isFetching: true,
        client: null
      };
    case 'FETCH_CLIENT_SUCCESS':
      return {
        isFetching: false,
        client: action.payload,
        error: null
      };
    case 'FETCH_CLIENT_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
